module.exports = __webpack_public_path__ + "638af725813347ca8c7a6b855f12f1f3.svg";